import * as Constants from '../../constants/resources';
import {
  Environments,
  License,
  LicenseDetailProperties
} from '../../types/resources/State';

export interface RequestLicenses {
  type: Constants.LICENSES;
}

export interface RequestLicensesSuccess {
  type: Constants.LICENSES_SUCCESS;
  payload: {
    licenses: License[];
  };
}
export interface RequestLicensesFailed {
  type: Constants.LICENSES_FAILED;
}

export interface RequestLicenseDetail {
  type: Constants.LICENSE_DETAIL;
  licenseVMID: string;
}
export interface SyncUsage {
  type: Constants.LICENSE_SYNC_USAGE;
  licenseVMID: string;
}

export interface RequestLicenseDetailSuccess {
  type: Constants.LICENSE_DETAIL_SUCCESS;
  payload: {
    licenseDetail: LicenseDetailProperties;
  };
}
export interface SyncUsageSuccess {
  type: Constants.LICENSE_SYNC_USAGE_SUCCESS;
  payload: {
    requestID: string;
  };
}
export interface RequestLicenseDetailFailed {
  type: Constants.LICENSE_DETAIL_FAILED;
}

export interface SyncUsageFailed {
  type: Constants.LICENSE_SYNC_USAGE_FAILED;
}

export interface RequestLicenseReferences {
  type: Constants.LICENSE_REFERENCES;
  licenseVMID: string;
}

export interface RequestLicenseReferencesSuccess {
  type: Constants.LICENSE_REFERENCES_SUCCESS;
  payload: {
    licenseReferences: Environments;
  };
}
export interface RequestLicenseReferencesFailed {
  type: Constants.LICENSE_REFERENCES_FAILED;
}
export type LicenseAction =
  | RequestLicenses
  | RequestLicensesSuccess
  | RequestLicenseDetail
  | RequestLicenseDetailSuccess
  | RequestLicenseDetailFailed
  | RequestLicenseReferences
  | RequestLicenseReferencesSuccess
  | RequestLicenseReferencesFailed
  | RequestLicensesFailed
  | SyncUsageSuccess
  | SyncUsageFailed
  | SyncUsage;

export const requestLicenses = (): RequestLicenses => ({
  type: Constants.LICENSES
});
export const requestLicensesSuccess = (
  licenses: License[]
): RequestLicensesSuccess => ({
  payload: { licenses },
  type: Constants.LICENSES_SUCCESS
});
export const requestLicensesFailed = (): RequestLicensesFailed => ({
  type: Constants.LICENSES_FAILED
});
export const requestLicenseDetail = (
  licenseVMID: string
): RequestLicenseDetail => ({
  type: Constants.LICENSE_DETAIL,
  licenseVMID
});
export const syncUsage = (licenseVMID: string): SyncUsage => ({
  type: Constants.LICENSE_SYNC_USAGE,
  licenseVMID
});

export const syncUsageSuccess = (requestID: string): SyncUsageSuccess => ({
  payload: { requestID },
  type: Constants.LICENSE_SYNC_USAGE_SUCCESS
});

export const syncUsageFailed = (): SyncUsageFailed => ({
  type: Constants.LICENSE_SYNC_USAGE_FAILED
});

export const requestLicenseDetailSuccess = (
  licenseDetail: LicenseDetailProperties
): RequestLicenseDetailSuccess => ({
  payload: { licenseDetail },
  type: Constants.LICENSE_DETAIL_SUCCESS
});

export const requestLicenseDetailFailed = (): RequestLicenseDetailFailed => ({
  type: Constants.LICENSE_DETAIL_FAILED
});

export const requestLicenseReferences = (
  licenseVMID: string
): RequestLicenseReferences => ({
  type: Constants.LICENSE_REFERENCES,
  licenseVMID
});

export const requestLicenseReferencesSuccess = (
  licenseReferences: Environments
): RequestLicenseReferencesSuccess => ({
  payload: { licenseReferences },
  type: Constants.LICENSE_REFERENCES_SUCCESS
});

export const requestLicenseReferencesFailed = (): RequestLicenseReferencesFailed => ({
  type: Constants.LICENSE_REFERENCES_FAILED
});
